var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LinkedInComp",
    clipPath: "url(#clip0_986_5203)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.48348 3.19218C6.48311 3.99902 6.18754 4.77266 5.66179 5.3429C5.13604 5.91315 4.42318 6.23328 3.68004 6.23287C2.93689 6.23247 2.22433 5.91156 1.6991 5.34075C1.17388 4.76994 0.879023 3.99598 0.879395 3.18913C0.879766 2.38229 1.17534 1.60865 1.70108 1.03841C2.22683 0.468166 2.93969 0.148034 3.68284 0.148438C4.42599 0.148841 5.13855 0.469747 5.66377 1.04056C6.18899 1.61137 6.48385 2.38533 6.48348 3.19218ZM6.56754 8.48563H0.963456V27.5299H6.56754V8.48563ZM15.422 8.48563H9.84593V27.5299H15.366V17.5362C15.366 11.969 22.0488 11.4518 22.0488 17.5362V27.5299H27.5829V15.4675C27.5829 6.08228 17.6917 6.43214 15.366 11.0411L15.422 8.48563Z",
    fill: "#FFFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_986_5203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.7035,
    height: 29.2069,
    fill: "white",
    transform: "translate(0.879395 0.148438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.776370e42a4b9f4662b1ec2a95095030.svg";
export { ForwardRef as ReactComponent };